import { createApp } from 'vue';
import { 
  IonicVue, 
  IonPage, 
  IonContent, 
  IonGrid, 
  IonRow, 
  IonCol, 
  IonHeader, 
  IonToolbar, 
  IonTitle, 
  IonButtons, 
  IonButton, 
  IonIcon, 
  IonLabel, 
  IonItem, 
  IonList,
  IonInput,
  IonCheckbox,
  IonApp,
  IonSplitPane,
  IonRouterOutlet,
  IonMenuToggle,
  IonSpinner,
  IonImg,
  IonSearchbar,
  IonSelect,
  IonSelectOption,
  IonBackButton,
  IonSegment,
  IonSegmentButton,
  IonThumbnail,
  IonChip,
  IonReorder,
  IonReorderGroup,
  IonMenu,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonDatetime,
  IonFab,
  IonFabButton,
  IonFabList,
  IonItemOption,
  IonItemOptions,
  IonItemSliding,
  IonListHeader,
  IonNote,
  IonRange,
  IonTextarea
} from '@ionic/vue';
import App from './App.vue';
import router from './router';
import store from './store';

// Firebase v9 compat – allows existing firebase.xyz() calls to keep working
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import firebaseCredentials from '@/constants/firebase.js';

/* Core Ionic CSS */
import '@ionic/vue/css/core.css';
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';
import '@/styles/snackbar.scss';
import '@/theme/variables.css';

// Firebase init
firebase.initializeApp(firebaseCredentials);
firebase.auth().onIdTokenChanged((auth) => store.dispatch('auth/updateUser', auth));

// Create the Vue 3 app
const app = createApp(App)
  .use(IonicVue)
  .use(store)
  .use(router);

app.component('ion-page', IonPage);
app.component('ion-content', IonContent);
app.component('ion-grid', IonGrid);
app.component('ion-row', IonRow);
app.component('ion-col', IonCol);
app.component('ion-header', IonHeader);
app.component('ion-toolbar', IonToolbar);
app.component('ion-title', IonTitle);
app.component('ion-buttons', IonButtons);
app.component('ion-button', IonButton);
app.component('ion-icon', IonIcon);
app.component('ion-label', IonLabel);
app.component('ion-item', IonItem);
app.component('ion-list', IonList);
app.component('ion-input', IonInput);
app.component('ion-checkbox', IonCheckbox);
app.component('ion-app', IonApp);
app.component('ion-split-pane', IonSplitPane);
app.component('ion-router-outlet', IonRouterOutlet);
app.component('ion-menu-toggle', IonMenuToggle);
app.component('ion-spinner', IonSpinner);
app.component('ion-img', IonImg);
app.component('ion-searchbar', IonSearchbar);
app.component('ion-select', IonSelect);
app.component('ion-select-option', IonSelectOption);
app.component('ion-back-button', IonBackButton);
app.component('ion-segment', IonSegment);
app.component('ion-segment-button', IonSegmentButton);
app.component('ion-thumbnail', IonThumbnail);
app.component('ion-chip', IonChip);
app.component('ion-reorder', IonReorder);
app.component('ion-reorder-group', IonReorderGroup);
app.component('ion-menu', IonMenu);
app.component('ion-card', IonCard);
app.component('ion-card-header', IonCardHeader);
app.component('ion-card-title', IonCardTitle);
app.component('ion-card-content', IonCardContent);
app.component('ion-datetime', IonDatetime);
app.component('ion-fab', IonFab);
app.component('ion-fab-button', IonFabButton);
app.component('ion-fab-list', IonFabList);
app.component('ion-item-option', IonItemOption);
app.component('ion-item-options', IonItemOptions);
app.component('ion-item-sliding', IonItemSliding);
app.component('ion-list-header', IonListHeader);
app.component('ion-note', IonNote);
app.component('ion-range', IonRange);
app.component('ion-textarea', IonTextarea);

import { addIcons } from 'ionicons';
import { 
  menu, 
  person, 
  warning, 
  alert, 
  home, 
  pricetags, 
  map, 
  business, 
  calendar, 
  glasses, 
  people, 
  trash, 
  refresh, 
  close, 
  copy,
  add,
  remove,
  camera,
  create,
  cloudUpload,
  barcode,
  radioButtonOn,
  radioButtonOff,
  sad,
  sync,
  logoEuro,
  ellipsisHorizontal,
  pricetag
} from 'ionicons/icons';
addIcons({
  'menu': menu,
  'contact': person,
  'person': person,
  'warning': warning,
  'alert': alert,
  'home': home,
  'pricetags': pricetags,
  'map': map,
  'business': business,
  'calendar': calendar,
  'glasses': glasses,
  'people': people,
  'trash': trash,
  'refresh': refresh,
  'close': close,
  'copy': copy,
  'add': add,
  'remove': remove,
  'camera': camera,
  'create': create,
  'cloud-upload': cloudUpload,
  'barcode': barcode,
  'radio-button-on': radioButtonOn,
  'radio-button-off': radioButtonOff,
  'sad': sad,
  'sync': sync,
  'logo-euro': logoEuro,
  'more': ellipsisHorizontal,
  'pricetag': pricetag
});

// Global $ready helper (migrated from Vue.mixin)
app.config.globalProperties.$ready = function $ready(fn) {
  if (import.meta.env.PROD) {
    return this.$nextTick(fn);
  }
  return setTimeout(() => {
    this.$nextTick(fn);
  }, 500);
};

// Mount after router is ready (Ionic standard)
router.isReady().then(() => {
  app.mount('#app');
});
